import './relevant-info.css';

export default function RelevantInfo({text}) {
  return (
    <p className='relevant-info'>{text}</p>
  )
}